import { rem } from 'polished'
import styled from 'styled-components'
import tw from 'twin.macro'

export const Root = styled.div`
  ${tw`select-none`};
`

export const Main = styled.div`
  ${tw`relative z-30 max-w-watchesMax mx-auto grid gap-y-12 justify-items-center pt-10 px-12`};
`

export const SoundControls = styled.div`
  ${tw`absolute z-30 top-0 right-0 mt-4 mr-4`};

  width: ${rem(44)};
  height: ${rem(44)};

  svg {
    ${tw`absolute top-1/2 left-1/2`}
    transform: translate(-50%,-50%);
    width: ${rem(24)};
    height: ${rem(24)};
    fill: #fff;
  }
`

export const VideoWrapper = styled.div`
  ${tw`relative overflow-hidden max-w-full`};
  padding-bottom: 56.25%;
  height: 0;
  background-color: #000;

  video {
    ${tw`absolute z-10 top-0 left-0 w-full h-full`}
  }

  &:before {
    content: '';
    ${tw`absolute z-20 bottom-0 left-0 w-full h-1/5 pointer-events-none`};
    margin-bottom: -1px;
    background: linear-gradient(
      to bottom,
      hsla(0, 0%, 5.5%, 0) 0%,
      hsla(0, 0%, 5.5%, 0.013) 8.1%,
      hsla(0, 0%, 5.5%, 0.049) 15.5%,
      hsla(0, 0%, 5.5%, 0.104) 22.5%,
      hsla(0, 0%, 5.5%, 0.175) 29%,
      hsla(0, 0%, 5.5%, 0.259) 35.3%,
      hsla(0, 0%, 5.5%, 0.352) 41.2%,
      hsla(0, 0%, 5.5%, 0.45) 47.1%,
      hsla(0, 0%, 5.5%, 0.55) 52.9%,
      hsla(0, 0%, 5.5%, 0.648) 58.8%,
      hsla(0, 0%, 5.5%, 0.741) 64.7%,
      hsla(0, 0%, 5.5%, 0.825) 71%,
      hsla(0, 0%, 5.5%, 0.896) 77.5%,
      hsla(0, 0%, 5.5%, 0.951) 84.5%,
      hsla(0, 0%, 5.5%, 0.987) 91.9%,
      hsl(0, 0%, 5.5%) 100%
    );
  }
`

export const PlayButton = styled.div`
  ${tw`absolute z-30 top-1/2 left-1/2 hidden`};
  transform: translate(-50%, -50%);

  width: ${rem(80)};
  height: ${rem(80)};

  @media (min-width: 520px) {
    width: ${rem(144)};
    height: ${rem(144)};
  }

  svg {
    width: ${rem(80)};
    height: ${rem(80)};

    @media (min-width: 520px) {
      width: ${rem(144)};
      height: ${rem(144)};
    }
  }
`

export const Text = styled.div`
  ${tw`text-left`};
  max-width: ${rem(530)};
`

export const LogoWrapper = styled.div`
  svg {
    width: 275px;
    height: auto;

    @media (min-width: 520px) {
      width: 394px;
    }
  }
`

export const LogosWrapper = styled.div`
  svg {
    width: 190px;
    height: auto;

    @media (min-width: 520px) {
      width: 284px;
    }
  }
`
